export default {
  setUsers (state, users) {
    state.users = users
  },

  setUser (state, user) {
    state.user = user
  },

  setEmail (state, email) {
    state.email = email
  },

  setPassword(state, password) {
    state.password = password
  },

  setTel (state, tel) {
    state.tel = tel
  },

  setName (state, name) {
    state.name = name
  },

  setBirthDayYear (state, birthDayYear) {
    state.birthDayYear = birthDayYear
  },

  setBirthDayMonth (state, birthDayMonth) {
    state.birthDayMonth = birthDayMonth
  },

  setBirthDayDate (state, birthDayDate) {
    state.birthDayDate = birthDayDate
  },

  setCountry (state, country) {
    state.country = country
  },

  setPrefecture (state, prefecture) {
    state.prefecture = prefecture
  },

  setAddress (state, address) {
    state.address = address
  },

  setAdmin (state, admin) {
    state.admin = admin
  }
}
